import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    item: 'font-regular text-m flex flex-row gap-[24px] py-[12.5px] leading-[140%] tracking-[2%] text-white',
    itemLabel: 'flex w-full gap-2.5',
    itemCircle: 'size-3 rounded-full',
    itemCircleWrapper: 'flex size-6 items-center justify-center',
    itemIcon: 'rotate-270 [&>path]:stroke-white',
    diamondIcon: 'size-6'
  },
  variants: {
    color: {
      primary: 'text-main'
    }
  },
  defaultVariants: {
    color: 'primary'
  }
});
